import React, { Component } from 'react';

import HeaderMaster from './HeaderMaster';
import HeaderSite from './HeaderSite';
import HeaderSimple from './HeaderSimple';
import Footer from './Footer';
import FooterSimple from './FooterSimple';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = { mobileMenu: false, isMobile: false };
    this.watchPageWidth = this.watchPageWidth.bind(this);
  }
  componentWillMount() {
    this.watchPageWidth();
  }
  componentDidMount() {
    window.addEventListener('resize', this.watchPageWidth);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.watchPageWidth);
  }
  watchPageWidth() {
    if (window.innerWidth > 991.8) {
      this.setState({ mobileMenu: false, isMobile: false });
      //    document.body.classList.remove('locked');
    } else {
      this.setState({ isMobile: true });
    }
  }
  render() {
    const { children, route } = this.props;
    const { mobileMenu, isMobile } = this.state;
    const toggleMobileMenu = () => {
      if (mobileMenu) {
        document.body.classList.remove('locked');
      } else {
        document.body.classList.add('locked');
      }
      this.setState({ mobileMenu: !mobileMenu });
    };
    return (
      <div className="body">
        <div className="site-mask" />
        <HeaderMaster {...{ mobileMenu, isMobile, toggleMobileMenu }} />
        {route !== 'checkout' &&
          <HeaderSite {...{ mobileMenu, isMobile, toggleMobileMenu }} />}
        {route === 'checkout' && <HeaderSimple />}
        {children}
        {route !== 'checkout' && <Footer />}
        {route === 'checkout' && <FooterSimple />}
      </div>
    );
  }
}

export default Layout;
